import { Link } from "react-router-dom";
import { clues } from "@/mocks/clueData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotRanking() {
  const ranked = [...clues].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-6">
      <SectionHeading eyebrow="热度榜" icon="ri-bar-chart-2-line" title="本周阅读排行" />
      <ol className="mt-6 flex flex-col divide-y divide-background-200">
        {ranked.map((clue, index) => (
          <li key={clue.id} className="flex items-start gap-4 py-4 first:pt-0 last:pb-0">
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                index < 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-700"
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0">
              <h3 className="line-clamp-2 text-sm font-semibold leading-6 text-foreground-950">
                <Link to={`/clues/${clue.slug}`} className="hover:text-primary-700">
                  {clue.title}
                </Link>
              </h3>
              <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                <span>{clue.categoryName}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {clue.views.toLocaleString()}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </aside>
  );
}